import { GetCustomerPartNumbersApiParameter } from "@auer-steel/Services/CustomerPartNumberService";
import { AuerState } from "@auer-steel/Store/AuerState";
import { getById, getDataView } from "@insite/client-framework/Store/Data/DataState";
import { createContext } from "react";

export function getCustomerPartNumbersState(state: AuerState, partNumber: string | undefined) {
    return getById(state.customerPartNumbers, partNumber, id => state.customerPartNumbers.idByProductNumber[id]);
}

export function getCustomerPartNumbersDataView(
    state: AuerState,
    getCustomerPartNumbersParameter: GetCustomerPartNumbersApiParameter,
) {
    return getDataView(state.customerPartNumbers, getCustomerPartNumbersParameter);
}

export const CustomerPartNumbersDataViewContext = createContext<ReturnType<typeof getCustomerPartNumbersDataView>>({
    value: undefined,
    isLoading: false,
});

export const CustomerPartNumberStateContext = createContext<ReturnType<typeof getCustomerPartNumbersState>>({
    value: undefined,
    isLoading: false,
    errorStatusCode: undefined,
    id: undefined,
});
